import React from 'react'
import { CustomTrace, RechartData, TraceSuffix } from 'src/Libs/chart-kit/shared/utils/chartModel'
import { UnitType } from 'src/Libs/types'
import BarChart from './BarChart'
import { ZoomIndexType } from 'src/Libs/system-charts/shared'
import type { ChartEventHandlers } from '../../shared/chart-event-handlers'

interface ComparisonChartProps {
  rechartData: RechartData
  unit: UnitType
  secondUnit?: string
  minPrefix?: number
  xAxisTicks: number[]
  xAxisFormat: string
  customTraces?: CustomTrace[]
  showForecast: boolean
  impossibleTraces: string[]
  hiddenTraces: string[]
  dstSwitchTs?: number
  onElementClick?: (props: Record<string, unknown>) => void
  height?: number
  legendHeight?: number
  headerHeight?: number
  legendWidth?: number
  traceSuffixes?: TraceSuffix[]
  chartEventHandlers: ChartEventHandlers
  children?: React.ReactNode
  zoomStartIndex?: ZoomIndexType
  zoomEndIndex?: ZoomIndexType
  calculatedMinPrefix?: number
}

const ComparisonChart: React.FC<ComparisonChartProps> = ({
  rechartData,
  unit,
  secondUnit,
  minPrefix,
  xAxisTicks,
  xAxisFormat,
  customTraces,
  showForecast,
  impossibleTraces,
  hiddenTraces,
  dstSwitchTs,
  onElementClick,
  height,
  legendHeight,
  headerHeight,
  legendWidth,
  traceSuffixes,
  chartEventHandlers,
  children,
  zoomStartIndex,
  zoomEndIndex,
  calculatedMinPrefix,
}) => {
  return (
    <BarChart
      unit={unit}
      secondUnit={secondUnit}
      xAxisFormat={xAxisFormat}
      rechartData={rechartData}
      customTraces={customTraces}
      showForecast={showForecast}
      impossibleTraces={impossibleTraces}
      hiddenTraces={hiddenTraces}
      dstSwitchTs={dstSwitchTs}
      xAxisTicks={xAxisTicks}
      onElementClick={onElementClick}
      height={height}
      legendHeight={legendHeight}
      legendWidth={legendWidth}
      minPrefix={minPrefix}
      traceSuffixes={traceSuffixes}
      chartEventHandlers={chartEventHandlers}
      zoomStartIndex={zoomStartIndex}
      zoomEndIndex={zoomEndIndex}
      headerHeight={headerHeight}
      calculatedMinPrefix={calculatedMinPrefix}
    >
      {children}
    </BarChart>
  )
}

export default ComparisonChart
